(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxSiteManagers(
    $window, $location, EventServiceEvents, GroupModel
  ) {
    return {
      restrict: 'EA',
      scope: {
        me: '=me',
        context: '=context',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/siteManagers/siteManagers.template.html',
      link: function(scope) {

        scope.siteManagers = [];
        scope.menuItems = [
          {
            name: 'Remove',
            icon: 'icon-delete',
            action: 'removeAdminGroup',
            disabled: scope.me.isSystemObserver()
          }
        ]
        scope.listMenuContext = null;
        scope.loading = true;

        (function() {
          getSiteManagers();
          setListeners();
        })();

        function getSiteManagers () {
          scope.context.getSiteWithEmbeddedResources().then(function(response) {
            if (response.siteAdminGroup) {
              scope.siteManagers = createGroupModel(response.siteAdminGroup);
            } else {
              scope.siteManagers = [];
            }
            scope.loading = false;
          }).catch(function(error){});
        }

        function createGroupModel (siteAdminGroup) {
          var groupList = []
          angular.forEach(siteAdminGroup, function(group) {
            groupList.push(new GroupModel(group));
          })
          return groupList;
        }

        scope.openListMenu = function (event, group) {

          scope.closeListMenu();
          scope.listMenuContext = group;
          scope.listMeta = {
            position: {left: event.clientX, top: event.clientY}
          }
        }

        scope.closeListMenu = function (group, action) {
          scope.listMenuContext = null;
          scope.listMeta = null;
          switch(action) {
            case 'removeAdminGroup':
              removeAdminGroupFromSite(group)
            break;
          }
        }

        function removeAdminGroupFromSite (group) {
          scope.loading = true;
          scope.context.removeSiteAdminGroup(group).then(function(response) {
            getSiteManagers();
          }).catch(function(error){});
        }

        scope.gotoProperties = function (group) {
          $window.open(group.info.targetUrl + '?groupSection=users', '_blank');
        }

        scope.addSiteManagers = function () {
          event.stopPropagation();
          var addManagerMeta = {
            title: "AddSiteManagerGroups",
            type: "addSiteManagers",
            bypassCloseOutside: true
          }
          scope.callback({meta: addManagerMeta});
        }

        function setListeners () {
          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_SITE_UPDATED, function(name, data) {
            if (data.site === scope.context.links.self.href) {
              getSiteManagers();
            }
          })
        }
      }
    };
  }

  pxSiteManagers.$inject = ['$window', '$location', 'EventServiceEvents', 'GroupModel'];

  angular
    .module('printix-admin')
    .directive('pxSiteManagers', pxSiteManagers);

})();
